var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSolidyFooter = function SvgSolidyFooter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4421 85.222L40.4916 143.851L62.8903 136.569L55.2347 74.2469L21.4421 85.222Z",
    fill: "url(#paint0_linear_420_1330)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.885 29.1504L10.0186 65.3802L23.8795 84.4595L80.7735 57.889L59.885 29.1504Z",
    fill: "url(#paint1_linear_420_1330)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.063 48.3793L75.2113 12.1495L61.3503 31.2138L104.189 77.1328L125.063 48.3793Z",
    fill: "url(#paint2_linear_420_1330)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.932 116.338L145.981 57.7096L123.568 50.4277L93.1543 105.363L126.932 116.338Z",
    fill: "url(#paint3_linear_420_1330)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8904 139.096H124.539V115.531L62.8904 103.569V139.096Z",
    fill: "url(#paint4_linear_420_1330)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_1330",
    x1: 51.9998,
    y1: 140.4,
    x2: 19.3956,
    y2: 73.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_1330",
    x1: 17.3332,
    y1: 75.4,
    x2: 82.0907,
    y2: 50.5102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_420_1330",
    x1: 70.1998,
    y1: 22.5333,
    x2: 121.109,
    y2: 75.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_420_1330",
    x1: 134.333,
    y1: 54.6,
    x2: 107.965,
    y2: 123.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_420_1330",
    x1: 124.8,
    y1: 129.133,
    x2: 60.9898,
    y2: 98.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDEBF2"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSolidyFooter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/solidy_footer.a99d5c9c.svg";
export { ForwardRef as ReactComponent };